import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LRV } from '../models/Lead-reseller-vf';
import { environment } from 'src/environments/environment';
import { IGenericResponse } from '../models/IGenericResponse';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { EditarUsuario } from '../models/PanelAdministracion';
@Injectable({
  providedIn: 'root'
})
export class PanelAdminService {

  private http = inject(HttpClient);
  private url = environment.api;

  constructor(private cookieService: CookieService) { }

  getUsuarios(): Observable<IGenericResponse> {
    const token = this.cookieService.get('authToken');
    if (!token) throw Error('No existe el token.');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<IGenericResponse>(`${this.url}/panelAdmin/getUsuarios`, { headers });
  }
  getProductosAsociados(id: number): Observable<IGenericResponse> {
    return this.http.get<IGenericResponse>(`${this.url}/panelAdmin/getProductosAsociados/${id}`);
  }
  getDistribuidores(): Observable<IGenericResponse> {
    return this.http.get<IGenericResponse>(`${this.url}/panelAdmin/distribuidores`);
  }

  editarUsuario(editar_usuario: EditarUsuario): Observable<IGenericResponse> {
    return this.http.put<IGenericResponse>(`${this.url}/panelAdmin/usuario`, editar_usuario);
  }
  
}